import { j as r } from "../../../../jsx-runtime.BREq8dyb.js";
import { Box as a, Switch as o, switchClasses as n, Typography as i } from "@mui/joy";
import { memo as s } from "react";
const h = s(({
  checked: c,
  ...e
}) => /* @__PURE__ */ r.jsx(a, { sx: (t) => ({
  my: t.spacing(1),
  px: t.spacing(1)
}), children: /* @__PURE__ */ r.jsx(o, { checked: c, color: "primary", size: "md", ...e, slotProps: {
  track: {
    children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx(i, { component: "span", fontSize: 9, level: "inherit", sx: {
        ml: "6px"
      }, children: "And" }),
      /* @__PURE__ */ r.jsx(i, { component: "span", fontSize: 9, level: "inherit", sx: (t) => ({
        color: t.palette.background.body,
        mr: "6px"
      }), children: "Or" })
    ] })
  }
}, sx: (t) => ({
  "&.Mui-checked": {
    "&:hover": {
      "--Switch-trackBackground": t.palette.primary[500]
    },
    "--Switch-thumbBackground": "white",
    "--Switch-trackBackground": t.palette.primary[500]
  },
  [`& .${n.thumb}`]: {
    transition: "width 0.2s, left 0.2s"
  },
  "&:hover": {
    "--Switch-trackBackground": t.palette.secondary[500]
  },
  "--Switch-thumbBackground": "white",
  "--Switch-thumbSize": "22px",
  "--Switch-trackBackground": t.palette.secondary[500],
  "--Switch-trackHeight": "26px",
  "--Switch-trackWidth": "50px"
}) }) }));
h.displayName = "AudienceSwitch";
export {
  h as default
};
//# sourceMappingURL=AudienceSwitch.js.map
